/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable */
import dayjs from 'dayjs';
import { DATE_FORMAT_COLUMN_TABLE } from 'constants/dateFormat';
import { Modal, Accordion, FullLoader } from 'components';
import { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Col, Row, Input, Select } from 'antd';
import PropTypes from 'prop-types';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
// import { scrollToErrorField } from 'utils/form/scollToErrorFiled';
import { showAlert } from 'actions/alert.actions';
import { videoSamples, splitBase64 } from 'utils/fileVideosBase64Parts';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import {
  newScrollToErrorField,
  encontrarActiveKeyPorValor
} from 'utils/form/newScrollToErrorField';
import {
  BENEFICIADOS,
  ESTADOS,
  PROCESOS_ELECTORALES,
  TIPO_MONITOREOS,
  UNIDADES_MEDIDA
} from 'constants/nombresCatalogos';
import InfoModal from 'components/InfoModal/InfoModal';
import { FORMAT_BACKEND } from 'constants/dateFormat';
import { upsertMonitoreosMediosImp, sendPartVideosInternet } from 'actions/monitoreos.actions';
import { newFormatBeneficiados } from 'adapters/adapterMonitoreosMediosImpresos';
// import moment from 'moment';
import * as fieldMsgs from 'constants/formFieldsMessages';
import { getMenuPermissions } from 'utils/getMenuPermissions';
import { NOMBRE_MENU_MEDIOS_IMPRESOS, NOMBRE_MENU_PERMISO_VALIDAR } from 'constants/menuNombres';
import { selectMenuState } from 'selectors/auth.selector';
import Muestras from './components/Muestras';
import Observaciones from './components/Observaciones';
import Beneficiados from '../../../../Beneficiados/Beneficiados';
import DatosGenerales from './components/DatosGenerales';
import DatosHallazgo from './components/DatosHallazgo';

import './ModalEditarMedImp.scss';

// MNI - Llamado a generación de PDF
import { generarPDFMonitoreos } from 'services/monitoreos.service';

export const ModalEditarMedImp = ({
  formEditar,
  titleModal,
  isModalOpen,
  setIsModalOpen,
  loadingModal,
  medioToEdit,
  setIdEstatusHallazgo,
  dataBeneficiados,
  setDataBeneficiados,
  catNombreMedImp,
  setCatNombreMedImp,
  reasonCancelField,
  nombreMedImpEsOtro,
  setNombreMedImpEsOtro,
  onClose
}) => {
  const entidades = useSelector(selectCatalogByName(ESTADOS));
  const catUnidadesMedida = useSelector(selectCatalogByName(UNIDADES_MEDIDA)); // Campo "tipo de medida"
  const catProcesosElectorales = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const tipoMonitoreosData = useSelector(selectCatalogByName(TIPO_MONITOREOS));
  const catBeneficiados = useSelector(selectCatalogByName(BENEFICIADOS));
  const menu = useSelector(selectMenuState);

  const [idProcesoGeneral, setIdProcesoGeneral] = useState(null);

  const [validacionError, setValidacionError] = useState(null);


  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [activeKey, setActiveKey] = useState([]);
  const identificadoresForm = {
    datos_generales: [
      'idEstado',
      'idProcesoEspecifico',
      'idMunicipio',
      'idAmbito',
      'idDistritoLoc',
      'idDistritoFed',
      'idPeriodo'
    ],
    muestras: ['muestra1', 'muestra2'],
    beneficiados: ['tipo_beneficio'],
    datosHallazgo: [
      'idTipoHallazgo',
      'idSubTipoHallazgo',
      'editorial',
      'seccion',
      'pagina',
      'fechaPublicacion',
      'idTipoMedida',
      'leyendaPagada',
      'responsablePago'
    ],
    observaciones: ['validacionCNCS', 'tipoValoracion', 'lema', 'valoraciones']
  };

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  // Define las fechas iniciales
  // const inicioOtroPeriodo = formEditar.getFieldValue('hallazgos');
  // const finOtroPeriodo = formEditar.getFieldValue('hallazgos');

  // Convertir las fechas iniciales a objetos moment
  // const initialRangeDates = [
  //  moment(inicioOtroPeriodo, 'YYYY-MM-DD'),
  //  moment(finOtroPeriodo, 'YYYY-MM-DD')
  // ];

  // Catálogo para campo "Tipo de medio impreso"
  let catTipoMedioImp = null;
  for (let i = 0; i < tipoMonitoreosData.length; i += 1) {
    if (tipoMonitoreosData[i].idTipoMonitoreo === 2) {
      // tipoHallazgos
      catTipoMedioImp = tipoMonitoreosData[i].tipoHallazgos;
    }
  }
  const catTipoAsociaciones = [];
  for (let i = 0; i < catBeneficiados.length; i += 1) {
    const objetoABuscar = {
      idTipoAsociacion: catBeneficiados[i].idTipoAsociacion,
      tipoAsociacion: catBeneficiados[i].tipoAsociacion
    };
    if (
      !catTipoAsociaciones.some((item) => JSON.stringify(item) === JSON.stringify(objetoABuscar))
    ) {
      catTipoAsociaciones.push(objetoABuscar);
    }
  }
  // Armar catalogo de sujetos obligados
  const catSujetosObligados = [];
  for (let i = 0; i < catBeneficiados.length; i += 1) {
    const objetoABuscar = {
      idSujetoObligado: catBeneficiados[i].idSujetoObligado,
      sujetoObligado: catBeneficiados[i].sujetoObligado
    };
    if (
      !catSujetosObligados.some((item) => JSON.stringify(item) === JSON.stringify(objetoABuscar))
    ) {
      catSujetosObligados.push(objetoABuscar);
    }
  }

  // const datos = useSelector((state) => state.validarUsuario.data);

  const [isLoading, setIsLoading] = useState(false);
  const [reasonCancel, setReasonCancel] = useState(false);
  const [tipoBeneficiadoInicial, setTipoBeneficiadoInicial] = useState(null);

  useEffect(() => 
  {
    if (!isModalOpen || !medioToEdit) 
    {
      return;
    }

    if(reasonCancelField != undefined && reasonCancelField != null)
    {
      setReasonCancel(true);
    }else{
      setReasonCancel(false);
    }

    const tipoBeneficio = medioToEdit.hallazgos?.[0]?.tipoBeneficio;
    setTipoBeneficiadoInicial(tipoBeneficio);
  }, [isModalOpen, medioToEdit]);

  useEffect(() => {
    if (validacionError) {
      dispatch(showAlert(validacionError, ALERT_ERROR_TYPE));
      setIsLoading(false);
      setValidacionError(null);  // Limpias el error para futuros usos
    }
  }, [validacionError]);


  const dispatch = useDispatch();

  const { Option } = Select;

  const concatValoraciones = (valoracionesString, valoracion, index) => {
    if (index === 0) {
      return `${valoracion}`;
    }
    return `${valoracionesString},${valoracion}`;
  };

  const getValoraciones = (valoracionesArray) => {
    let valoracionesString = '';
    let index = 0;
    if (valoracionesArray !== undefined && valoracionesArray !== null) {
      valoracionesArray.forEach((valoracion) => {
        valoracionesString = concatValoraciones(valoracionesString, valoracion, index);
        index += 1;
      });
      return valoracionesString;
    }
    return null;
  };

  // let listaAtributosMI = {};
  const replaceAtributosDatosHallazgo = (valoresParams) => {
    return {
      nombre: valoresParams.nombre || null,
      editorial: valoresParams.editorial || null,
      seccion: valoresParams.seccion || null,
      pagina: valoresParams.pagina || null,
      cantidad: valoresParams.cantidad || null,
      fechaPublicacion: valoresParams.fechaPublicacion?.format(FORMAT_BACKEND) || null,
      idTipoMedida: valoresParams.idTipoMedida || null,
      medidaN: valoresParams.medidaN || null,
      leyendaPagada: valoresParams.leyendaPagada !== undefined ? valoresParams.leyendaPagada : null,
      responsablePago: valoresParams.responsablePago || null
      // otraMedida: null
    };
    // console.log('lista atributos', listaAtributosMI);
  };

  /** const onChangeCuentaLeyenda = (e) => {
    console.log('radio checked', e.target.value);
    setCuentaLeyenda(e.target.value);
  }; */

  const handleCancel = () => {
    setIdProcesoGeneral(0);
    setIsModalOpen(false);
    setReasonCancel(false);
    setIdEstatusHallazgo(null);
    // setReasonCancelField(null);
    setDataBeneficiados([]);
    formEditar.setFieldsValue({
      descripcionProcesoGral: null,
      fechaRegistro: null,
      estado: null,
      idDistritoLoc: null,
      idDistritoFed: null,
      idProcesoEspecifico: null,
      idPeriodo: null,
      ambito: null,
      idEstado: null,
      tipoBeneficio: null,
      idTipoMedioImpreso: null,
      idTipoHallazgo: null,
      idSubTipoHallazgo: null,
      tipoMedioImpreso: null,
      seccion: null,
      pagina: null,
      cantidad: null,
      fechaPublicacion: null,
      tipoMedida: null,
      idUnidadMedida: null,
      leyendaPagada: null,
      responsablePago: null,
      tipoValoracion: null,
      lema: null,
      infAdicional: null,
      validacionCNCS: null
    });
    formEditar.resetFields();
  };

  const handleReasonCancel = (e) => {
    if (e === 3) {
      setReasonCancel(true);
    } else {
      setReasonCancel(false);
    }
  };

  function getIdMedidaByDescripcion(catalogo, desc) {
    let respuesta = desc;
    for (let i = 0; i < catalogo.length; i += 1) {
      if (catalogo[i].descripcion === desc) {
        respuesta = catalogo[i].idUnidadMedida;
        break;
      }
    }
    return respuesta;
  }

  function esTipoHallazgoOtro(idTipoHallazgo) {
    return catTipoMedioImp
      ?.find((medImp) => medImp?.idHallazgo === idTipoHallazgo)
      ?.nombreHallazgo?.includes('Otro');
  }

  function esSubTipoHallazgoOtro(idSubTipoHallazgo) {
    return catNombreMedImp
      ?.find((subHallazgo) => subHallazgo?.idTipoHallazgo === idSubTipoHallazgo)
      ?.nombreTipoHallazgo?.includes('Otro');
  }

  const processMuestras = async (muestrasOrdenadas) => {
    // Esperar todas las peticiones de sincronización
    for (const m of muestrasOrdenadas) 
      {
        if (m.muestra?.length > 1024 * 1024) 
        {
          const parts = splitBase64(m.muestra, 1024 * 1024);
          for (let index = 0; index < parts.length; index++) 
          {
            await sendPartVideosInternet(m.idMuestra, m.idHallazgo, index + 1, parts.length, parts[index]);
          }
        } else {
          await sendPartVideosInternet(m.idMuestra, m.idHallazgo, 1, 1, m.muestra);
        }
      }
  };

  const formatoMuestrasHallazgos = (formMuestras) => {
    const hallazgosFormateados = [
      {
        pkHallazgo: 1,
        muestras: [
          {
            pkMuestra: 1,
            muestra: formMuestras
              .getFieldValue('muestra1')
              ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          },
          {
            pkMuestra: 2,
            muestra: formMuestras
              .getFieldValue('muestra2')
              ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          },
          {
            pkMuestra: 3,
            muestra: formMuestras
              .getFieldValue('muestra3')
              ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          },
          {
            pkMuestra: 4,
            muestra: formMuestras
              .getFieldValue('muestra4')
              ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          },
          {
            pkMuestra: 5,
            muestra: formMuestras
              .getFieldValue('muestra5')
              ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          }
        ].filter((m) => m.muestra) // Quitamos los elementos que no tengan imagen
      }
    ];

    return hallazgosFormateados;
  };

  let muestrasEliminadas = [];

  const addMuestrasEliminadas = (muestraId, hallazgoId, statusMuestra) => {
    if (statusMuestra === undefined && muestraId !== undefined) {
      const muestraDeleted = {
        pkMuestra: muestraId,
        idMuestra: muestraId,
        idHallazgo: hallazgoId,
        estatus: 0
      };
      muestrasEliminadas.push(muestraDeleted);
    }
    return null;
  };

  const onFinishEditar = async (values) => 
  {
    setIsLoading(true);
    // let val = {};
    let valoresForm = {};
    let contadorMuestras = 0;
    let datosHallazgosFields = {};
    try 
    {
      valoresForm = await formEditar.validateFields();
      // console.log(valoresForm);
      // se reemplazan los valores de Datos del hallazgo por los valores correspondientes resetear los valores anteriores
      datosHallazgosFields = replaceAtributosDatosHallazgo(valoresForm);
      // val = await formEditar.validateFields(['beneficiados']);
      if (valoresForm.beneficiados.length === 0) 
      {
        // showAlert('Debes registrar al menos un beneficiado', ALERT_ERROR_TYPE);
        setValidacionError('Debes registrar al menos un beneficiado');
        setActiveKey('beneficiados');
        setIsLoading(false);
        return;
      }

      if (valoresForm.muestra1?.fileList && valoresForm.muestra1.fileList.length > 0) {
        contadorMuestras += 1;
      }
      if (valoresForm.muestra2?.fileList && valoresForm.muestra2.fileList.length > 0) {
        contadorMuestras += 1;
      }
      if (valoresForm.muestra3?.fileList && valoresForm.muestra3.fileList.length > 0) {
        contadorMuestras += 1;
      }
      if (valoresForm.muestra4?.fileList && valoresForm.muestra4.fileList.length > 0) {
        contadorMuestras += 1;
      }
      if (valoresForm.muestra5?.fileList && valoresForm.muestra5.fileList.length > 0) {
        contadorMuestras += 1;
      }

      if (contadorMuestras === 0 || contadorMuestras < 2) {
        setValidacionError('Revisa o espera la carga de las muestras ingresadas en la sección de Hallazgos');
        setActiveKey('muestras');
        setIsLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      const { errorFields } = error;
      setIsLoading(false);
      // if (errorFields) scrollToErrorField(errorFields, formEditar);
      if (errorFields) {
        const [firstError] = errorFields;
        const identifierForm = encontrarActiveKeyPorValor(
          identificadoresForm,
          firstError?.name?.[0]
        );

        if (identifierForm) {
          newScrollToErrorField(errorFields, formEditar);
          setActiveKey([`${identifierForm}`]);
        } else {
          setActiveKey([`${newScrollToErrorField(errorFields, formEditar)}`]);
        }
      }
      return;
    }
    setReasonCancel(false);

    const idPeriodoEdit = formEditar.getFieldValue('idPeriodo');
    let fechaInicioOtroFormat = null;
    let fechaFinOtroFormat = null;
    const isOtroTipoHallazgo = formEditar.getFieldValue('idTipoHallazgo') === 122;

    if (idPeriodoEdit !== undefined && idPeriodoEdit !== null && idPeriodoEdit === 0) {
      const fechaInicioOtro = formEditar.getFieldValue('inicioOtroPeriodo');
      const fechaFinOtro = formEditar.getFieldValue('finOtroPeriodo');
      if (
        fechaInicioOtro !== undefined &&
        (fechaInicioOtro?.$d !== undefined || fechaInicioOtro.includes('z'))
      ) {
        fechaInicioOtroFormat = fechaInicioOtro.format(FORMAT_BACKEND);
      } else {
        fechaInicioOtroFormat = fechaInicioOtro;
      }
      if (
        fechaFinOtro !== undefined &&
        (fechaFinOtro?.$d !== undefined || fechaFinOtro.includes('z'))
      ) {
        fechaFinOtroFormat = fechaFinOtro.format(FORMAT_BACKEND);
      } else {
        fechaFinOtroFormat = fechaFinOtro;
      }
    }

    // setLoading(false); // true
    values.idHallazgo = medioToEdit.hallazgos[0].idHallazgo;
    values.tipoMedida = values.tipoMedida
      ? getIdMedidaByDescripcion(catUnidadesMedida, values.tipoMedida)
      : 1;
    values.idProcesoEspecifico = 1;

    const tipoSubTipoHallazgos = catTipoMedioImp.find((tipo) => tipo.idHallazgo === formEditar.getFieldValue('idTipoHallazgo'))?.subTipoHallazgos;

    let beneficiadosFormato = null;
    beneficiadosFormato =newFormatBeneficiados(valoresForm.beneficiados, catBeneficiados, values.idProcesoEspecifico, dataBeneficiados );

    // Se realiza limpieza de valores innecesarios cuando se guarda un beneficiado genérico
      if(formEditar.getFieldValue('tipo_beneficio') == 1) {
        beneficiadosFormato?.forEach(element => {
          if(element.estatus != 0) {
            element.estado            = '';
            element.idMunicipio       = null;
            element.municipio         = '';
            element.nombreBeneficiado = '';
            element.idContabilidad    = 0;
          }
        });
      }

    const estructura = {
      pkMonitoreo: medioToEdit.idMonitoreo,
      idMonitoreo: medioToEdit.idMonitoreo,
      idTipoMonitoreo: 2,
      estatusMonitoreo: 2,
      idProcesoGral: values.idProcesoGral,
      idDistritoLoc: values.idDistritoLoc,
      idDistritoFed: values.idDistritoFed,
      descripcionProcesoGral: catProcesosElectorales.find(
        (proc) => proc.idProcesoElectoral === values.idProcesoGral
      )
        ? catProcesosElectorales.find((proc) => proc.idProcesoElectoral === values.idProcesoGral)
            .descripcion
        : null,
      idTipoEleccion: catProcesosElectorales.find(
        (proc) => proc.idProcesoElectoral === values.idProcesoGral
      )
        ? catProcesosElectorales.find((proc) => proc.idProcesoElectoral === values.idProcesoGral)
            .idTipoEleccion
        : null,
      idAmbito: values.idAmbito,
      idEstado: entidades.find((edo) => edo.nombreEstado === values.estado)
        ? entidades.find((edo) => edo.nombreEstado === values.estado).idEstado
        : medioToEdit?.idEstado,
      tipoRegistro: 2,
      notificarPartido: 0,
      hallazgos: [
        {
          pkHallazgo: 1,
          estatus: formEditar.getFieldValue('estatusHallazgo'),
          idHallazgo: medioToEdit.hallazgos[0].idHallazgo,
          idMonitoreo: medioToEdit.idMonitoreo,
          idProcesoEspecifico: formEditar.getFieldValue('idProcesoEspecifico'),
          tipoRegistro: 2,
          // estatus: formEditar.getFieldValue('estatus'),
          motivoCancelacion: formEditar.getFieldValue('motivoCancelacionEditar'),
          idDistritoLoc: formEditar.getFieldValue('idDistritoLoc'),
          idDistritoFed: formEditar.getFieldValue('idDistritoFed'),
          // fechaCreacion: dayjs.now.format(DATE_STRING_TO_MOMENT),
          idPeriodo: idPeriodoEdit,
          inicioOtroPeriodo: fechaInicioOtroFormat,
          finOtroPeriodo: fechaFinOtroFormat,
          idTipoHallazgo: formEditar.getFieldValue('idTipoHallazgo'),
          idAmbito: formEditar.getFieldValue('idAmbito'),
          cantidad: formEditar.getFieldValue('cantidad'),
          editorial: formEditar.getFieldValue('editorial'),
          responsablePago: formEditar.getFieldValue('responsablePago'),
          tipoHallazgo:
            catTipoMedioImp.find(
              (medImp) => medImp.idHallazgo === formEditar.getFieldValue('idTipoHallazgo')
            ).nombreHallazgo !== undefined
              ? catTipoMedioImp.find(
                  (medImp) => medImp.idHallazgo === formEditar.getFieldValue('idTipoHallazgo')
                ).nombreHallazgo
              : null, // tipo de medio impreso  // ------> antes "nombre"
          otroTipoHallazgo: isOtroTipoHallazgo
            ? formEditar.getFieldValue('otroTipoHallazgo')
            : null,
          idSubTipoHallazgo: esTipoHallazgoOtro(formEditar.getFieldValue('idTipoHallazgo'))
            ? 0
            : formEditar.getFieldValue('idSubTipoHallazgo'),
          subTipoHallazgo:tipoSubTipoHallazgos.find(
            (subHallazgo) =>
              subHallazgo.idTipoHallazgo === formEditar.getFieldValue('idSubTipoHallazgo')
          )?.nombreTipoHallazgo !== undefined ?
          tipoSubTipoHallazgos.find(
            (subHallazgo) =>
              subHallazgo.idTipoHallazgo === formEditar.getFieldValue('idSubTipoHallazgo')
          )?.nombreTipoHallazgo
          :null,
          otroSubTipoHallazgo: formEditar.getFieldValue('otroSubTipoHallazgo'),
          seccion: formEditar.getFieldValue('seccion'),
          pagina: parseInt(formEditar.getFieldValue('pagina'), 10),
          /* fechaPublicacion: moment(
            form.getFieldValue('fechaPublicacion'),
            DATE_FORMAT_FILTER_COLUMN
          ).format(DATE_STRING_TO_MOMENT), */
          fechaPublicacion: formEditar.getFieldValue('fechaPublicacion')
            ? formEditar.getFieldValue('fechaPublicacion').format(FORMAT_BACKEND)
            : null,
          tipoMedida: values.tipoMedida,
          medidaN: catUnidadesMedida.find(
            (medida) => medida.idUnidadMedida === values.idUnidadMedida
          )
            ? catUnidadesMedida.find((medida) => medida.idUnidadMedida === values.idUnidadMedida)
                .descripcion
            : null,
          leyendaPagada: formEditar.getFieldValue('leyendaPagada'),
          idTipoMedida: formEditar.getFieldValue('idTipoMedida'),
          tipoValoracion: formEditar.getFieldValue('tipoValoracion'),
          validacionCNCS: formEditar.getFieldValue('validacionCNCS'),
          infAdicional: formEditar.getFieldValue('infAdicional'),
          lema: formEditar.getFieldValue('lema'),
          tipoBeneficio: valoresForm.tipo_beneficio,
          valoraciones:
            formEditar.getFieldValue('tipoValoracion') === 2
              ? getValoraciones(formEditar.getFieldValue('valoraciones'))
              : '',
          muestras: [
            {
              pkMuestra: 1,
              muestra:
                formEditar
                  .getFieldValue('muestra1')
                  ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
                'data:video/mp4;base64'
                  ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_1.mp4'
                  : formEditar
                      .getFieldValue('muestra1')
                      ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
              idHallazgo: medioToEdit.hallazgos[0].idHallazgo,
              idMuestra:
                formEditar.getFieldValue('muestra1')?.file?.status === 'removed'
                  ? formEditar.getFieldValue('idMuestra1')
                  : addMuestrasEliminadas(
                      formEditar.getFieldValue('idMuestra1'),
                      medioToEdit.hallazgos[0].idHallazgo,
                      formEditar.getFieldValue('muestra1')?.fileList[0]?.status
                    ),
              estatus: formEditar.getFieldValue('muestra1')?.file?.status === 'removed' ? 0 : 1
            },
            {
              pkMuestra: 2,
              muestra:
                formEditar
                  .getFieldValue('muestra2')
                  ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
                'data:video/mp4;base64'
                  ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_2.mp4'
                  : formEditar
                      .getFieldValue('muestra2')
                      ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
              idHallazgo: medioToEdit.hallazgos[0].idHallazgo,
              idMuestra:
                formEditar.getFieldValue('muestra2')?.file?.status === 'removed'
                  ? formEditar.getFieldValue('idMuestra2')
                  : addMuestrasEliminadas(
                      formEditar.getFieldValue('idMuestra2'),
                      medioToEdit.hallazgos[0].idHallazgo,
                      formEditar.getFieldValue('muestra2')?.fileList[0]?.status
                    ),
              estatus: formEditar.getFieldValue('muestra2')?.file?.status === 'removed' ? 0 : 1
            },
            {
              pkMuestra: 3,
              muestra:
                formEditar
                  .getFieldValue('muestra3')
                  ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
                'data:video/mp4;base64'
                  ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_3.mp4'
                  : formEditar
                      .getFieldValue('muestra3')
                      ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
              idHallazgo: medioToEdit.hallazgos[0].idHallazgo,
              idMuestra:
                formEditar.getFieldValue('muestra3')?.file?.status === 'removed'
                  ? formEditar.getFieldValue('idMuestra3')
                  : addMuestrasEliminadas(
                      formEditar.getFieldValue('idMuestra3'),
                      medioToEdit.hallazgos[0].idHallazgo,
                      formEditar.getFieldValue('muestra3')?.fileList[0]?.status
                    ),
              estatus: formEditar.getFieldValue('muestra3')?.file?.status === 'removed' ? 0 : 1
            },
            {
              pkMuestra: 4,
              muestra:
                formEditar
                  .getFieldValue('muestra4')
                  ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
                'data:video/mp4;base64'
                  ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_4.mp4'
                  : formEditar
                      .getFieldValue('muestra4')
                      ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
              idHallazgo: medioToEdit.hallazgos[0].idHallazgo,
              idMuestra:
                formEditar.getFieldValue('muestra4')?.file?.status === 'removed'
                  ? formEditar.getFieldValue('idMuestra4')
                  : addMuestrasEliminadas(
                      formEditar.getFieldValue('idMuestra4'),
                      medioToEdit.hallazgos[0].idHallazgo,
                      formEditar.getFieldValue('muestra4')?.fileList[0]?.status
                    ),
              estatus: formEditar.getFieldValue('muestra4')?.file?.status === 'removed' ? 0 : 1
            },
            {
              pkMuestra: 5,
              muestra:
                formEditar
                  .getFieldValue('muestra5')
                  ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
                'data:video/mp4;base64'
                  ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_5.mp4'
                  : formEditar
                      .getFieldValue('muestra5')
                      ?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
              idHallazgo: medioToEdit.hallazgos[0].idHallazgo,
              idMuestra:
                formEditar.getFieldValue('muestra5')?.file?.status === 'removed'
                  ? formEditar.getFieldValue('idMuestra5')
                  : addMuestrasEliminadas(
                      formEditar.getFieldValue('idMuestra5'),
                      medioToEdit.hallazgos[0].idHallazgo,
                      formEditar.getFieldValue('muestra5')?.fileList[0]?.status
                    ),
              estatus: formEditar.getFieldValue('muestra5')?.file?.status === 'removed' ? 0 : 1
            }
          ].filter((m) => m.muestra || m.estatus === 0),
          beneficiados: beneficiadosFormato
         /* beneficiados: newFormatBeneficiados(
            valoresForm.beneficiados,
            catBeneficiados,
            values.idProcesoEspecifico,
            dataBeneficiados 
          )*/
        }
      ]
    };

    const data = {
      hallazgos: {
        toUpdate: []
      },
      monitoreos: {
        toUpdate: [],
        toCancel: []
      }
    };

    // Se reemplazan los valores de Datos del hallazgo en la petición
    data.hallazgos.toUpdate.push({ ...estructura.hallazgos[0], ...datosHallazgosFields });

    // Se agregan las muestras eliminadas
    muestrasEliminadas?.map((muestraEliminada) =>
      data.hallazgos.toUpdate[0].muestras.push(muestraEliminada)
    );

    // Verifica si se cambió el estatus. Si es cancelado se envía a cancelar el monitoreo
    if (
      formEditar.getFieldValue('estatusHallazgo') !== medioToEdit.estatusMonitoreo &&
      formEditar.getFieldValue('estatusHallazgo') === 3
    ) {
      data.monitoreos.toCancel = [
        {
          pkMonitoreo: medioToEdit.idMonitoreo,
          idMonitoreo: medioToEdit.idMonitoreo,
          motivoCancelacion: formEditar.getFieldValue('motivoCancelacionEditar')
        }
      ];
    }
    const updatedMonitoreo = { 
      pkMonitoreo: medioToEdit.idMonitoreo,
      idMonitoreo: medioToEdit.idMonitoreo,
      idEstado: valoresForm.idEstado,
      fechaRegistro:dayjs(formEditar.getFieldValue('fechaRegistro'), 'YYYYMMDDHHmmss')
      .locale('es')
      .format(FORMAT_BACKEND),
      idProcesoGral: valoresForm.idProcesoGral,
      idProcesoEspecifico: valoresForm.idProcesoEspecifico,
      idAmbito: valoresForm.idAmbito,
      idDistritoLoc: valoresForm.idDistritoLoc,
      idDistritoFed: valoresForm.idDistritoFed,
      tipoRegistro: 2,
      idTipoMonitoreo: 2,
      descripcionProcesoGral: catProcesosElectorales.find(
        (proc) => proc.idProcesoElectoral === values.idProcesoGral
      ),
      estatusMonitoreo: formEditar.getFieldValue('estatusHallazgo'), 
      motivoCancelacion: formEditar.getFieldValue('motivoCancelacionEditar')!== undefined ? formEditar.getFieldValue('motivoCancelacionEditar') : ''
    };
    data.monitoreos.toUpdate.push(updatedMonitoreo);

    try 
    {
      const { success, hallazgos: hallazgosMonitoreo, idMonitoreo } = await dispatch(
        upsertMonitoreosMediosImp(data)
      );

      // console.log('hallazgosMonitoreo: ', hallazgosMonitoreo);

      if (success) 
      {
        // Variable a enviar para generar PDF del monitoreo
        let monitoreoPDF = [{
            idMonitoreo     : updatedMonitoreo.idMonitoreo 
          , idTipoMonitoreo : 2
          , tiposActa       : [{ "id": 4 }]
        }];

        const hallazgos = formatoMuestrasHallazgos(formEditar);
        const muestrasOrdenadas = videoSamples(hallazgosMonitoreo, hallazgos);
        if (muestrasOrdenadas.length > 0) 
        {
          await processMuestras(muestrasOrdenadas)
            .then(async () => 
            {
              setIsLoading(false);
              setIsModalOpen(false);
              setIsVisibleSuccessModal(true);
              muestrasEliminadas = [];

              // Se genera PDF una vez que se han almacenado las Muestras
              let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

              if(generoPDF)
              {
                console.log('Se generó correctamente el PDF');
              }else{
                console.log('Error al generar el PDF');
              }
            })
            .catch((error) => {
              console.error('Error procesando las muestras:', error);
            });
            setIdProcesoGeneral(0);
        } else {
          setIsLoading(false);
          setIsModalOpen(false);
          setIsVisibleSuccessModal(true);
          muestrasEliminadas = [];

          // Se genera PDF una vez que se han almacenado las Muestras
          let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

          if(generoPDF)
          {
            console.log('Se generó correctamente el PDF');
          }else{
            console.log('Error al generar el PDF');
          }
          setIdProcesoGeneral(0);
        }
         onClose();
      }
      formEditar.resetFields();
    } catch (error) {
      console.log(error);
    }

    // console.log('=========== data.monitoreos.hallazgos: ', data.hallazgos.toUpdate);
    setIsLoading(false);
  };

  // vincular todos los formularios
  const items = useMemo(
    () => [
      {
        key: 'muestras',
        label: 'Muestras',
        forceRender: true,
        children: <Muestras form={formEditar} isLoading={isLoading} />
      },
      {
        key: 'datos_generales',
        label: 'Datos Generales',
        forceRender: true,
        children: <DatosGenerales form={formEditar} idProcesoEsp = { idProcesoGeneral } />
      },
      {
        key: 'beneficiados',
        label: 'Beneficiados',
        forceRender: true,
        children: (
          <Beneficiados
            form={formEditar}
            isLoading={isLoading}
            renderBeneficiados={Math.floor(Math.random() * 100)}
            tipoBeneficioInicial={tipoBeneficiadoInicial}
            actionType={!!medioToEdit}
          />
        )
      },
      {
        key: 'datosHallazgo',
        label: 'Datos de Hallazgo',
        forceRender: true,
        children: (
          <DatosHallazgo
            form={formEditar}
            catNombreMedImp={catNombreMedImp}
            setCatNombreMedImp={setCatNombreMedImp}
            nombreMedImpEsOtro={nombreMedImpEsOtro}
            setNombreMedImpEsOtro={setNombreMedImpEsOtro}
          />
        )
      },
      {
        key: 'observaciones',
        label: 'Observaciones',
        forceRender: true,
        children: <Observaciones form={formEditar} isLoading={isLoading} />
      }
    ],
    [isLoading, formEditar, tipoBeneficiadoInicial, idProcesoGeneral]
  );

  const handleIdProcesoGralChange = (e) => 
  {
    try 
    {
      setIdProcesoGeneral(e); 
    } catch (error) 
    {
      console.log('Error: ', error);  
    }
  };

  return (
    <>
      <InfoModal
        visible={isVisibleSuccesModal}
        onClose={() => setIsVisibleSuccessModal(false)}
        description="Actualización exitosa"
      />
      <Modal
        transparent
        open={isLoading}
        footer={null}
        closeOnOverlayClick={false}
        cancelButtonProps={{ style: { display: 'none' } }}
        centered
        width="85%"
        className="modal-formulario-overlay"
        wrapClassName="modal-formulario-overlay">
        <FullLoader className="loader-modal" visible={isLoading} />
      </Modal>
      <Modal
        title={titleModal}
        open={isModalOpen}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { marginLeft: '-1em' }, disabled: isLoading }}
        okText="Guardar"
        onOk={onFinishEditar}
        onCancel={handleCancel}
        centered
        width="85%"
        wrapClassName="modal-formulario-monitoreo">
        <FullLoader className="loader-modal" visible={loadingModal} />

        {!loadingModal && (
          <div>
            <div style={{ color: '#CDCCCC', fontSize: '12px' }}>
              <span className="folio-moni">
                Folio de monitoreo: <span className="value-folio">{medioToEdit?.folio}</span>
              </span>
            </div>
            <div className="div-instrucciones">
              <span style={{ color: '#9159CB' }}>Captura la información solicitada.</span>
              <span style={{ color: 'red' }}>*Campos obligatorios.</span>
            </div>
            <Form
              id="formEditMedImp"
              className="form-med-imp"
              layout="vertical"
              form={formEditar}
              initialValues={medioToEdit}>
              <Row>
                <Col span={8}>
                  <Form.Item
                    name="idProcesoGral"
                    label="Proceso Electoral:"
                    rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                    <Select onSelect={handleIdProcesoGralChange}>
                      {catProcesosElectorales?.length > 0
                        ? catProcesosElectorales.map((data) => (
                            <Option key={data.idProcesoElectoral} value={data.idProcesoElectoral}>
                              {data.descripcion}
                            </Option>
                          ))
                        : null}
                    </Select>
                  </Form.Item>
                </Col>
                {getMenuPermissions(
                  menu,
                  NOMBRE_MENU_MEDIOS_IMPRESOS,
                  null,
                  NOMBRE_MENU_PERMISO_VALIDAR
                ) ? (
                  <>
                    <Col span={6}>
                      <Form.Item
                        style={{ marginLeft: '20px' }}
                        name="estatusHallazgo"
                        label="Estatus:"
                        rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                        <Select
                          placeholder="Selecciona..."
                          allowClear
                          onChange={handleReasonCancel}
                          options={[
                            { value: 2, label: 'No validado' },
                            { value: 3, label: 'Cancelado' },
                            { value: 4, label: 'Validado' }
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      {reasonCancel &&
                        <Form.Item
                          style={{ marginLeft: '20px' }}
                          name="motivoCancelacionEditar"
                          label="Motivo de cancelación:"
                          rules={[
                            {
                              required: true,
                              message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                            }
                          ]}>
                          <Input.TextArea rows={2} placeholder="Ingresa el motivo de cancelación" />
                        </Form.Item>
                      }
                    </Col>
                  </>
                ) : null}
              </Row>
              <Accordion
                items={items}
                className="modal-formulario-secciones"
                activeKey={activeKey}
                onChange={handleCollapseChange}
              />
            </Form>
          </div>
        )}
      </Modal>
    </>
  );
};

ModalEditarMedImp.propTypes = {
  onClose: PropTypes.func.isRequired,
  formEditar: PropTypes.shape({
    validateFields: PropTypes.func.isRequired,
    getFieldValue: PropTypes.func.isRequired
  }).isRequired,
  titleModal: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  loadingModal: PropTypes.bool.isRequired,
  medioToEdit: PropTypes.shape({ folio: PropTypes.string.isRequired }).isRequired,
  dataBeneficiados: PropTypes.shape({}).isRequired
};

ModalEditarMedImp.defaultProps = {};
